import { render, staticRenderFns } from "./Magoza.vue?vue&type=template&id=05bbf052&scoped=true&"
import script from "./Magoza.vue?vue&type=script&lang=js&"
export * from "./Magoza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bbf052",
  null
  
)

export default component.exports